import { z } from "zod";

export const stripeCreateConnectionBodySchema = z.object({
    /**
     * Omitted when an accounting firm connects from the
     * organization view: the connection is created without a
     * client and its accounts are assigned afterwards.
     */
    workspaceId: z.string().uuid().optional(),
    authCode: z.string(),
    defaultEntityId: z.number().optional(),
});
